module.exports = __webpack_public_path__ + "assets/img/00046.160de1dc.png";